import{Link as e}from"./src/Link.js";customElements.define("sp-link",e);
//# sourceMappingURL=sp-link.js.map
